import { LoadboardListRequest, LoadboardRequest } from '@trukt/tms-api';
import { createKey } from '../createKey';

const keyHandler = createKey('loadboard');

export const LoadboardServiceKeys = {
  key: keyHandler.key,
  list: keyHandler.createMethod<LoadboardListRequest>(),
  getById: keyHandler.createMethod<LoadboardRequest>(),
};
